// @ts-nocheck
import { Component, Inject, Vue, Watch } from 'vue-property-decorator';
import { VERSION } from '@/constants';
import LoginService from '@/account/login.service';

import AccountService from '@/account/account.service';
import TranslationService from '@/locale/translation.service';
import AdminService from '@/admin/admin.service';
import { Authority } from '@/shared/security/authority';
import PortalUserService from '../../entities/portal-user/portal-user.service';
import AdvertisementCategoryService from '../../entities/advertisement-category/advertisement-category.service';

import AdvertisementSubCategoryService from '../../entities/advertisement-subcategory/advertisement-subcategory.service';

import AdvertisementCategory from '../../entities/advertisement/advertisement.service';

import { AdvertisementTypeOptions } from '@/shared/model/advertisement-type.model';
import { IAdvertisementSubcategory } from '@/shared/model/advertisement-subcategory.model';
import { IPortalUser } from '@/shared/model/portal-user.model';
import AdvertisementService from '../../entities/advertisement/advertisement.service';
import buildPaginationQueryOpts from '@/shared/sort/sorts';

import SearchPageService from '../../core/b2b-jhi-navbar/searchpage.service';
import RequestsPreviewService from '../../entities/requests-preview/requests-preview.service';
import CollaborationService from '../../entities/collaboration/collaboration.service';

@Component
export default class B2BJhiNavbar extends Vue {
  @Inject('loginService')
  private loginService: () => LoginService;
  @Inject('translationService') private translationService: () => TranslationService;
  @Inject('adminService') private adminService: () => AdminService;

  @Inject('accountService') private accountService: () => AccountService;

  @Inject('portalUserService') private portalUserService: () => PortalUserService;

  @Inject('advertisementService') private advertisementService: () => AdvertisementService;

  @Inject('advertisementCategoryService') private advertisementCategoryService: () => AdvertisementCategoryService;

  @Inject('advertisementSubcategoryService') private advertisementSubcategoryService: () => AdvertisementSubCategoryService;

  @Inject('searchPageService') private searchPageService: () => SearchPageService;

  @Inject('requestsPreviewService') private requestsPreviewService: () => RequestsPreviewService;

  @Inject('collaborationService') private collaborationService: () => CollaborationService;

  public version = VERSION ? 'v' + VERSION : '';
  private currentLanguage = this.$store.getters.currentLanguage;
  private languages: any = this.$store.getters.languages;
  private hasAnyAuthorityValue = false;
  private isPrviNavVisible = true;
  private mainSearchCategory = null;
  public portalUser: IPortalUser = null;
  public companyId: number;
  public companyLink = '';
  private advCategList = null;
  public advSubCategList: IAdvertisementSubcategory[] = [];
  private txtsearchNav;
  //private mainSearchCategory = null;
  private mainSearchSubCategory = null;
  public advertisements = null;
  public cmsnews = null;
  public cmsquestions = null;
  public companies = null;
  public isActive: boolean = false;
  public valuetype;
  public advertisementTypeOptions = AdvertisementTypeOptions;
  public selectedSubcategory: IAdvertisementSubcategory | null = null;
  public isAdminValue = false;
  public isCompanyAdminValue = false;
  public isCMSSuperAdminValue = false;
  public isCMSAdminValue = false;
  public isSuperAdminValue = false;
  public isNioAdminValue = false;
  public isCompanyOrgAdminValue = false;
  public isNioOrgAdminValue = false;
  public isNioUserValue = false;
  public isCompanyUserValue = false;
  public isCompanySuperAdminValue = false;
  public isNioSuperAdminValue = false;
  public newRequestsCount = 0;
  public newCollaborationsCount = 0;

  public category;

  //private companies;
  private questions;
  private news;

  public itemsPerPage = 10;
  public queryCount: number = null;
  public page = 1;
  public previousPage = 1;
  public propOrder = 'id';
  public reverse = false;
  public totalItems = 0;
  public isFetching = false;
  beforeRouteEnter(to, from, next) {
    to(vm => {
      vm.initRelationships();
    });
  }

  async created() {
    this.translationService().refreshTranslation(this.currentLanguage);
    this.mainSearchCategory = 1;
    this.mainSearchSubCategory = 1;

    // Wait for all role checks to complete before rendering
    await Promise.all([
      this.setIsAdmin(),
      this.setIsCompanyAdmin(),
      this.setIsCMSSuperAdmin(),
      this.setIsCMSAdmin(),
      this.setIsSuperAdmin(),
      this.setIsNioAdmin(),
      this.setIsCompanyOrgAdmin(),
      this.setIsNioOrgAdmin(),
      this.setIsNioUser(),
      this.setIsCompanyUser(),
      this.setIsCompanySuperAdmin(),
      this.setIsNioSuperAdmin(),
    ]);

    // Fetch new requests and collaborations count after authentication is confirmed
    if (this.authenticated) {
      this.fetchNewRequestsCount();
      this.fetchNewCollaborationsCount();
    }
  }

  // Watch for authentication changes and update roles
  @Watch('authenticated')
  async onAuthenticationChanged(newValue: boolean, oldValue: boolean) {
    if (newValue && newValue !== oldValue) {
      // User just logged in, refresh all role checks
      await Promise.all([
        this.setIsAdmin(),
        this.setIsCompanyAdmin(),
        this.setIsCMSSuperAdmin(),
        this.setIsCMSAdmin(),
        this.setIsSuperAdmin(),
        this.setIsNioAdmin(),
        this.setIsCompanyOrgAdmin(),
        this.setIsNioOrgAdmin(),
        this.setIsNioUser(),
        this.setIsCompanyUser(),
        this.setIsCompanySuperAdmin(),
        this.setIsNioSuperAdmin(),
      ]);

      await this.portalUserService().getRoles();

      // Fetch new requests and collaborations count after login
      this.fetchNewRequestsCount();
      this.fetchNewCollaborationsCount();
    }
  }

  data() {
    return {
      advertisements: [],
      cmsnews: [],
      cmsquestions: [],
      companies: [],
      txtsearchNav: '',
      mainSearchCategory: 1,
      mainSearchSubCategory: 1,
      valuetype: [],
      options: [
        { name: 'Оглас', value: '0' },
        { name: 'Вест', value: '1' },
        { name: 'Компанија', value: '2' },
        { name: 'Најчешћа питања', value: '3' },
      ],
    };
  }

  beforeMount() {
    // conosle.log('u beforemount')
    this.$emit('update', this.advertisements);
  }

  public escapeHTML(txt): any {
    var text = '';
    if (txt != null && txt != '' && txt !== 'undefined') {
      text = this.$sanitize(txt);

      // var re = new RegExp("[^-A-Za-z0-9+&@#/%?=~_|!:,.;\(\)]");
      var re = new RegExp('[^\\p{L}0-9\\s]', 'gu');
      text = text.replace(re, '');
      // if (re.test(text)) {
      // return '';
      // }

      var html = text.toString();
      var div = document.createElement('div');
      div.innerHTML = html;
      text = div.textContent || div.innerText || '';

      // console.log(text)
    }
    return text;
  }
  mounted() {
    this.initRelationships();
    // Call the function to check screen size and update isActive
    this.checkScreenSize();
    // Add event listener to track window resize
    window.addEventListener('resize', this.checkScreenSize);

    this.txtsearchNav = this.escapeHTML(this.$route.query.search);
    this.mainSearchCategory = this.escapeHTML(this.$route.query.category);
    this.mainSearchSubCategory = this.escapeHTML(this.$route.query.category);

    //// console.log( this.$route.query)

    if (this.txtsearchNav == null) {
      const urlParams = new URLSearchParams(window.location.search);
      this.txtsearchNav = urlParams.get('search');
      this.mainSearchCategory = urlParams.get('category');
      this.mainSearchSubCategory = urlParams.get('category');
    }
  }

  beforeDestroy() {
    // Remove event listener when component is destroyed
    window.removeEventListener('resize', this.checkScreenSize);
  }

  public checkScreenSize() {
    this.isActive = window.innerWidth < 786;
  }

  public subIsActive(input) {
    const paths = Array.isArray(input) ? input : [input];
    return paths.some(path => {
      return this.$route.path.indexOf(path) === 0; // current path starts with this path string
    });
  }

  public changeLanguage(newLanguage: string): void {
    this.translationService().refreshTranslation(newLanguage);
  }

  public isActiveLanguage(key: string): boolean {
    return key === this.$store.getters.currentLanguage;
  }
  /*
  public logout(): void {
    localStorage.removeItem('jhi-authenticationToken');
    sessionStorage.removeItem('jhi-authenticationToken');
    this.$store.commit('logout');
    this.$router.push('/');
  }
*/
  public async logout(): Promise<void> {
    // Check user authorities to determine logout type
    const isCompanyUser = await this.hasAnyAuthority(Authority.COMPANY_USER);
    const isCompanyAdmin = await this.hasAnyAuthority(Authority.COMPANY_ADMIN);
    const isCompanySuperAdmin = await this.hasAnyAuthority(Authority.COMPANY_SUPER_ADMIN);
    const isSuperAdmin = await this.hasAnyAuthority(Authority.SUPER_ADMIN);
    const isNioAdmin = await this.hasAnyAuthority(Authority.NIO_ADMIN);
    const isNioOrgAdmin = await this.hasAnyAuthority(Authority.NIO_ORG_ADMIN);
    const isCompanyOrgAdmin = await this.hasAnyAuthority(Authority.COMPANY_ORG_ADMIN);

    // Company users and company admins use admin logout
    // Company super admin + company admin combination uses regular logout
    const shouldUseAdminLogout =
      isCompanyUser || (isCompanyAdmin && !isCompanySuperAdmin) || isSuperAdmin || isNioAdmin || isNioOrgAdmin || isCompanyOrgAdmin;

    if (shouldUseAdminLogout) {
      this.adminService()
        .adminLogout()
        .then(() => {
          this.$store.commit('logout');
          this.$router.push('/');
        })
        .catch(error => {
          console.error('Error during admin logout:', error);
          this.performRegularLogout();
        });
    } else {
      this.performRegularLogout();
    }
  }

  private performRegularLogout(): void {
    this.loginService()
      .logout()
      .then(response => {
        this.$store.commit('logout');
        this.$router.push('/');
        const data = response.data;
        let logoutUrl = data.logoutUrl;
        // if Keycloak, uri has protocol/openid-connect/token
        if (logoutUrl.indexOf('/protocol') > -1) {
          logoutUrl = logoutUrl + '?redirect_uri=' + window.location.origin;
        } else {
          // Okta
          logoutUrl = logoutUrl + '?id_token_hint=' + data.idToken + '&post_logout_redirect_uri=' + window.location.origin;
        }
        window.location.href = logoutUrl;
      });
  }
  public openLogin(): void {
    //this.loginService().openLogin((<any>this).$root); old for jwt auth.
    this.loginService().login();
  }

  public get authenticated(): boolean {
    this.getCompanyLink();
    return this.$store.getters.authenticated;
  }

  public async hasAnyAuthority(authorities: any): Promise<boolean> {
    return await this.accountService().hasAnyAuthorityAndCheckAuth(authorities);
    // this.accountService()
    // .hasAnyAuthorityAndCheckAuth(authorities)
    // .then(value => {
    //     this.hasAnyAuthorityValue = value;
    //   });
    // return this.hasAnyAuthorityValue;
  }

  public async setIsAdmin(): Promise<void> {
    this.isAdminValue = (await this.hasAnyAuthority('ROLE_ADMIN')) || (await this.hasAnyAuthority('ROLE_SUPER_ADMIN'));
  }

  public async setIsCompanyAdmin(): Promise<void> {
    this.isCompanyAdminValue = await this.hasAnyAuthority('ROLE_COMPANY_ADMIN');
  }

  public async setIsCMSSuperAdmin(): Promise<void> {
    this.isCMSSuperAdminValue = await this.hasAnyAuthority('ROLE_CMS_SUPER_ADMIN');
  }

  public async setIsCMSAdmin(): Promise<void> {
    this.isCMSAdminValue = await this.hasAnyAuthority('ROLE_CMS_ADMIN');
  }

  public async setIsSuperAdmin(): Promise<void> {
    this.isSuperAdminValue = await this.hasAnyAuthority('ROLE_SUPER_ADMIN');
  }

  public async setIsNioAdmin(): Promise<void> {
    this.isNioAdminValue = await this.hasAnyAuthority('ROLE_NIO_ADMIN');
  }

  public async setIsCompanyOrgAdmin(): Promise<void> {
    this.isCompanyOrgAdminValue = await this.hasAnyAuthority('ROLE_COMPANY_ORGANIZATION_ADMIN');
  }

  public async setIsNioOrgAdmin(): Promise<void> {
    this.isNioOrgAdminValue = await this.hasAnyAuthority('ROLE_NIO_ORGANIZATION_ADMIN');
  }

  public async setIsNioUser(): Promise<void> {
    this.isNioUserValue = await this.hasAnyAuthority('ROLE_NIO_USER');
  }

  public async setIsCompanyUser(): Promise<void> {
    this.isCompanyUserValue = await this.hasAnyAuthority('ROLE_COMPANY_USER');
  }

  public async setIsCompanySuperAdmin(): Promise<void> {
    this.isCompanySuperAdminValue = await this.hasAnyAuthority('ROLE_COMPANY_SUPER_ADMIN');
  }

  public async setIsNioSuperAdmin(): Promise<void> {
    this.isNioSuperAdminValue = await this.hasAnyAuthority('ROLE_NIO_SUPER_ADMIN');
  }

  get isAdmin(): boolean {
    return this.isAdminValue;
  }

  get isCompanyAdmin(): boolean {
    return this.isCompanyAdminValue;
  }

  get isCompanySuperAdmin(): boolean {
    return this.isCompanySuperAdminValue;
  }

  get isCMSSuperAdmin(): boolean {
    return this.isCMSSuperAdminValue;
  }

  get isCMSAdmin(): boolean {
    return this.isCMSAdminValue;
  }

  get isSuperAdmin(): boolean {
    return this.isSuperAdminValue;
  }

  get isNioAdmin(): boolean {
    return this.isNioAdminValue;
  }

  get isCompanyOrgAdmin(): boolean {
    return this.isCompanyOrgAdminValue;
  }

  get isNioOrgAdmin(): boolean {
    return this.isNioOrgAdminValue;
  }

  get isNioUser(): boolean {
    return this.isNioUserValue;
  }

  get isCompanyUser(): boolean {
    return this.isCompanyUserValue;
  }
  get isNioSuperAdmin(): boolean {
    return this.isNioSuperAdminValue;
  }

  // Helper to check if user has any B2B role
  get hasB2BRole(): boolean {
    return this.isCompanyAdmin || this.isCompanySuperAdmin || this.isCompanyUser || this.isCompanyOrgAdmin || this.isSuperAdmin;
  }

  get hasB2BAdminRole(): boolean {
    return this.isCompanyAdmin || this.isCompanySuperAdmin || this.isCompanyOrgAdmin || this.isSuperAdmin;
  }

  public get swaggerEnabled(): boolean {
    return this.$store.getters.activeProfiles.indexOf('swagger') > -1;
  }

  public get inProduction(): boolean {
    return this.$store.getters.activeProfiles.indexOf('prod') > -1;
  }

  public get userRoles(): any {
    return this.$store.getters.roles;
  }

  public getCompanyLink(): string {
    const user = this.$store.getters.account;
    if (user) {
      this.portalUserService()
        .findByUserId(user.id)
        .then(res => {
          this.portalUser = res;
          if (this.portalUser?.company) {
            this.companyLink = '/company/' + this.portalUser.company.id + '/view';
          }
        });
    }

    return this.companyLink;
  }

  private advList;
  public sort(): Array<any> {
    const result = [this.propOrder + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.propOrder !== 'id') {
      result.push('id');
    }
    return result;
  }
  public searchFound;
  public notifsearchshown = false;

  // public autoAdv(): any {
  //   // console.log('kuku');
  //   if (!this.notifsearchshown) {
  //     this.$notify({
  //       text: JSON.stringify(this.$t('global.navbar.autosearchnote')),
  //       type: 'info',
  //       duration: 3000,
  //     });
  //     this.notifsearchshown = true;
  //   }
  //   if (this.txtsearchNav != null && this.txtsearchNav.length >= 3) {
  //     this.isFetching = true;

  //     const paginationQuery = {
  //       page: this.page - 1,
  //       size: this.itemsPerPage,
  //       sort: this.sort(),
  //     };

  //     this.advertisementService()
  //       .retrieveBaseSearch(this.txtsearchNav, this.mainSearchCategory, paginationQuery)
  //       .then(
  //         res => {
  //           // Ovo koristiti az originalno povucene rezultate pretrage
  //           this.advertisements = res.data;
  //           this.$emit('adv:change', this.advertisements);
  //           // Ovo koristiti za filtrirane rezultate pretrage
  //           this.totalItems = Number(res.headers['x-total-count']);
  //           this.queryCount = this.totalItems;
  //           this.isFetching = false;
  //         },
  //         err => {
  //           this.isFetching = false;
  //         }
  //       );
  //   }
  // }

  public autoAdvSub(): any {
    // // console.log('kuku');
    this.txtsearchNav = this.escapeHTML(this.txtsearchNav);

    if (this.txtsearchNav == null || this.txtsearchNav.length < 3) {
      this.isFetching = false;
      this.advertisements = null;
      this.$emit('adv:change', this.advertisements);
      return;
    }

    if (!this.notifsearchshown) {
      /*this.$notify({
        text: JSON.stringify(this.$t('global.navbar.autosearchnote')),
        type: 'info',
        duration: 3000,
      });*/
      this.notifsearchshown = true;
    }

    if (this.txtsearchNav != null && this.txtsearchNav.length >= 3) {
      this.isFetching = true;

      const paginationQuery = {
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort(),
      };

      if (this.selectedSubcategory != null) {
        this.mainSearchSubCategory = this.selectedSubcategory.id;
      } else {
        this.mainSearchSubCategory = 1;
      }

      this.advertisementService()
        .retrieveBaseSearchSub(this.txtsearchNav, this.mainSearchSubCategory, paginationQuery)
        .then(
          res => {
            // Ovo koristiti az originalno povucene rezultate pretrage
            this.advertisements = res.data;
            this.$emit('adv:change', this.advertisements);
            // Ovo koristiti za filtrirane rezultate pretrage
            this.totalItems = Number(res.headers['x-total-count']);
            this.queryCount = this.totalItems;
            this.isFetching = false;
          },
          err => {
            this.isFetching = false;
          }
        );
    }
  }

  public searchAdv(): any {
    //this.advertisements = ['kukuriku'];

    // // console.log(this.advertisements);

    //	if (this.valuetype!= null && typeof(this.valuetype) != 'undefined'  && this.valuetype.length == 1) {
    //const searchtype = this.valuetype[0].value;

    // // console.log(this.valuetype[0].value);
    this.txtsearchNav = this.escapeHTML(this.txtsearchNav);
    if (this.txtsearchNav.length == 0) return;

    const searchtype = 0;

    const baseApiUrlSearchAdv = '/b2b/advertisement-search';
    const baseApiUrlSearchCmp = '/b2b/company-search';
    const baseApiUrlSearchQA = '/b2b/cms-questions/search';
    const baseApiUrlSearchNews = '/b2b/cms-news/search';

    var ppathAdv = baseApiUrlSearchAdv + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchCategory}`;
    var ppathCmp = baseApiUrlSearchCmp + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchCategory}`;
    var ppathQa = baseApiUrlSearchQA + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchCategory}`;
    var ppathNw = baseApiUrlSearchNews + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchCategory}`;
    var ppath = '';

    switch (Number(searchtype)) {
      case 0:
        ppath = ppathAdv;
        break;
      case 1:
        ppath = ppathNw;
        break;
      case 2:
        ppath = ppathCmp;
        break;
      case 3:
        ppath = ppathQa;
        break;
      default:
        ppath = ppathAdv;
        break;
    }

    window.location.href = ppath;
    //}

    //	// console.log(this.valuetype);

    /*
	if (this.valuetype != null && typeof(this.valuetype) != 'undefined'  && this.valuetype.length > 1) {

	const num = this.valuetype.length;

	for (var i = 0; i <= num - 1; i++)
	{
		const val = this.valuetype[i].value;

		if (val == '0') {
				this.searchPageService()
				 .retrieveSearchAdv(this.txtsearchNav)
			      .then(resa => {
			        //// console.log(resa.data);
			        this.advList = resa.data;
			        this.advertisements = resa.data;
			        //this.advertisements.push(resa.data);
			       this.$emit('adv:change', this.advertisements);

			      // // console.log(this.advertisements);

			      });
		    }

		 if (val == '2') {
			     this.searchPageService()
				 .retrieveSearchCmp(this.txtsearchNav)
			      .then(resc => {
			       // // console.log(resc.data);
			        this.advList = resc.data;
			        this.companies = resc.data;

			        this.$emit('companies:change', this.companies);

			      });
		 }

		  if (val == '3') {
			      this.searchPageService()
				 .retrieveSearchQA(this.txtsearchNav)
			      .then(resqa => {
			       // // console.log(resqa.data);
			        this.advList = resqa.data;
			        this.questions= resqa.data;
			        this.cmsquestions = resqa.data;
			        // console.log(this.cmsquestions);
			        this.$emit('quests:change', this.cmsquestions);

		  		    });
		  }
		  if (val == '1') {

		     	this.searchPageService()
			 		.retrieveSearchNW(this.txtsearchNav)
		      		.then(resnw => {
		        		//// console.log(resnw.data);
		        		this.advList = resnw.data;
		        		this.news = resnw.data;
		        		this.cmsnews = resnw.data;
			        	this.$emit('news:change', this.cmsnews);


		     	 });
		 	}

		}

		*/

    //// console.log(this.txtsearchNav + Number(this.mainSearchCategory) );
  }

  public searchAdvSub(): any {
    //this.advertisements = ['kukuriku'];

    // // console.log(this.advertisements);

    //	if (this.valuetype!= null && typeof(this.valuetype) != 'undefined'  && this.valuetype.length == 1) {
    //const searchtype = this.valuetype[0].value;

    // // console.log(this.valuetype[0].value);

    this.txtsearchNav = this.escapeHTML(this.txtsearchNav);

    const searchtype = 0;

    if (this.txtsearchNav.length == 0) return;

    const baseApiUrlSearchAdv = '/b2b/advertisement-search-sub';
    const baseApiUrlSearchCmp = '/b2b/company-search';
    const baseApiUrlSearchQA = '/b2b/cms-questions/search';
    const baseApiUrlSearchNews = '/b2b/cms-news/search';

    // var ppathAdv = baseApiUrlSearchAdv + `?search=${this.txtsearchNav}` + `&category=` + `&subc=${this.mainSearchSubCategory}`;
    var ppathAdv = baseApiUrlSearchAdv + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchSubCategory}` + `&subc=1`;
    var ppathCmp = baseApiUrlSearchCmp + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchCategory}`;
    var ppathQa = baseApiUrlSearchQA + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchCategory}`;
    var ppathNw = baseApiUrlSearchNews + `?search=${this.txtsearchNav}` + `&category=${this.mainSearchCategory}`;
    var ppath = '';

    switch (Number(searchtype)) {
      case 0:
        ppath = ppathAdv;
        break;
      case 1:
        ppath = ppathNw;
        break;
      case 2:
        ppath = ppathCmp;
        break;
      case 3:
        ppath = ppathQa;
        break;
      default:
        ppath = ppathAdv;
        break;
    }

    window.location.href = ppath;
    //}

    //	// console.log(this.valuetype);

    /*
	if (this.valuetype != null && typeof(this.valuetype) != 'undefined'  && this.valuetype.length > 1) {

	const num = this.valuetype.length;

	for (var i = 0; i <= num - 1; i++)
	{
		const val = this.valuetype[i].value;

		if (val == '0') {
				this.searchPageService()
				 .retrieveSearchAdv(this.txtsearchNav)
			      .then(resa => {
			        //// console.log(resa.data);
			        this.advList = resa.data;
			        this.advertisements = resa.data;
			        //this.advertisements.push(resa.data);
			       this.$emit('adv:change', this.advertisements);

			      // // console.log(this.advertisements);

			      });
		    }

		 if (val == '2') {
			     this.searchPageService()
				 .retrieveSearchCmp(this.txtsearchNav)
			      .then(resc => {
			       // // console.log(resc.data);
			        this.advList = resc.data;
			        this.companies = resc.data;

			        this.$emit('companies:change', this.companies);

			      });
		 }

		  if (val == '3') {
			      this.searchPageService()
				 .retrieveSearchQA(this.txtsearchNav)
			      .then(resqa => {
			       // // console.log(resqa.data);
			        this.advList = resqa.data;
			        this.questions= resqa.data;
			        this.cmsquestions = resqa.data;
			        // console.log(this.cmsquestions);
			        this.$emit('quests:change', this.cmsquestions);

		  		    });
		  }
		  if (val == '1') {

		     	this.searchPageService()
			 		.retrieveSearchNW(this.txtsearchNav)
		      		.then(resnw => {
		        		//// console.log(resnw.data);
		        		this.advList = resnw.data;
		        		this.news = resnw.data;
		        		this.cmsnews = resnw.data;
			        	this.$emit('news:change', this.cmsnews);


		     	 });
		 	}

		}

		*/

    //// console.log(this.txtsearchNav + Number(this.mainSearchCategory) );
  }

  private searchinput;

  public initRelationships(): void {
    this.advertisementCategoryService()
      .retrieve()
      .then(res => {
        this.advCategList = res.data;
        this.$refs.mainSearchCategory = this.advCategList;
        this.mainSearchCategory = 1;
      });

    this.advertisementSubcategoryService()
      .retrieve()
      .then(res => {
        this.advSubCategList = res.data;
        // // console.log(this.advSubCategList);
        // Error in production
        this.$refs.mainSearchSubCategory = null; //this.advSubCategList;
        //this.mainSearchSubCategory = 1;
        this.mainSearchSubCategory = this.$route.query.category;
        if (this.mainSearchSubCategory == null || this.mainSearchSubCategory === 'undefined') {
          const urlParams = new URLSearchParams(window.location.search);
          this.mainSearchSubCategory = urlParams.get('category');
        }
        if (this.mainSearchSubCategory == null || this.mainSearchSubCategory === 'undefined') {
          this.mainSearchSubCategory = 1;
        }
      });
  }

  public getSubcategoryName(subcategory: IAdvertisementSubcategory) {
    const currentLanguage = this.$store.getters.currentLanguage;

    if (currentLanguage === 'sr') {
      return subcategory.name;
    } else if (currentLanguage === 'src') {
      return subcategory.nameSrc;
    } else if (currentLanguage === 'en') {
      return subcategory.nameEn;
    } else {
      return '';
    }
  }

  public hideSearchResults() {
    this.txtsearchNav = null;
    this.isFetching = false;
    this.advertisements = null;
    this.selectedSubcategory = null;
    this.$emit('adv:change', this.advertisements);
  }

  get isHomepage(): boolean {
    return this.$route.path === '/b2b';
  }

  get isAdvPage(): boolean {
    return this.$route.path.includes('/advertisement-search');
  }

  public async fetchNewRequestsCount(): Promise<void> {
    try {
      // Fetch all incoming requests (we need to filter on client side)
      const [servicesResponse, infrastructuresResponse] = await Promise.all([
        this.requestsPreviewService().getServiceRequests('incoming', 0, 1000),
        this.requestsPreviewService().getInfrastructureRequests('incoming', 0, 1000),
      ]);

      // Count only requests without a respond (unanswered)
      const serviceRequests = servicesResponse.data.content || servicesResponse.data || [];
      const infrastructureRequests = infrastructuresResponse.data.content || infrastructuresResponse.data || [];

      const unansweredServicesCount = serviceRequests.filter((request: any) => !request.requestForServiceRespond).length;
      const unansweredInfrastructuresCount = infrastructureRequests.filter((request: any) => !request.requestForInfrastructureRespond)
        .length;

      // Sum up the counts of unanswered requests only
      this.newRequestsCount = unansweredServicesCount + unansweredInfrastructuresCount;
    } catch (error) {
      // Silently fail - don't show error to user, just set count to 0
      this.newRequestsCount = 0;
    }
  }

  public async fetchNewCollaborationsCount(): Promise<void> {
    try {
      if (!this.companyId) {
        this.newCollaborationsCount = 0;
        return;
      }

      // Fetch collaborations where my company is the advertiser (companyOffer)
      // collaborationSideFlags: [true, false] means we want collaborations where companyOffer is our company
      const response = await this.collaborationService().retrieveByCompany(
        this.companyId,
        [], // Empty array to get all statuses, we'll filter on client
        [true, false], // Get collaborations where our company is companyOffer (advertiser)
        [], // ratingSideFlags - not relevant for this count
        { page: 0, size: 1000 } // Get all to count
      );

      const collaborations = response.data.content || response.data || [];

      // Count only collaborations with PENDING status where my company is companyOffer
      const pendingCollaborationsCount = collaborations.filter((collaboration: any) => {
        return collaboration.status?.statusEn === 'Pending' && collaboration.companyOffer?.id === this.companyId;
      }).length;

      this.newCollaborationsCount = pendingCollaborationsCount;
    } catch (error) {
      // Silently fail - don't show error to user, just set count to 0
      this.newCollaborationsCount = 0;
    }
  }

  public getUserInitials(): string {
    const account = this.$store.getters.account;
    if (account && account.firstName && account.lastName) {
      const initials = `${account.firstName.charAt(0)}${account.lastName.charAt(0)}`.toUpperCase();
      return initials;
    }
    return '';
  }

  /**
   * Check if current route is an advertisement-related page
   * Used for breadcrumb/active menu highlighting
   */
  public get isAdvertisementRoute(): boolean {
    const currentPath = this.$route?.path || '';
    const currentName = this.$route?.name || '';

    // Check for advertisement-related routes
    const advertisementPaths = [
      '/advertisement',
      '/b2b/advertisement',
      '/research-infrastructure-pregled',
      '/ri-service-pregled',
      '/organization-preview',
    ];

    const advertisementNames = [
      'AdvertisementNew',
      'AdvertisementView',
      'AdvertisementEdit',
      'ResearchInfrastructurePregled',
      'RiServicePregled',
      'OrganizationPreview',
    ];

    // Check if path starts with any advertisement path
    const pathMatch = advertisementPaths.some(path => currentPath.startsWith(path));

    // Check if route name matches
    const nameMatch = advertisementNames.includes(currentName);

    return pathMatch || nameMatch;
  }
}
